<template>
    <main class="container my-2">
        <div v-if="!sucesso">
            <div class="mt-5  text-center">
                <p class="mt-3">
                    <i class="fa-solid fa-trash-can-arrow-up icon"></i>
                </p>
                <p class="mt-3" style="font-size:18px;"><strong>Após encerrada, não é possível reativar sua
                        conta</strong>
                </p>
                <p class="mt-3">Ao encerrar sua conta, <strong>você terá que aguardar até 60 dias para criar uma nova
                        conta</strong>, caso queira volta a usar o aplicativo.</p>
                <p class="mt-3">Além disso, <strong>você tambem perderá de forma irreversível seus recursos, produtos e
                        serviços ativos.</strong></p>

            </div>

            <div v-if="erro" class="card my-2 badge-danger text-center p-3 text-uppercase m-3">
                {{ erro }}
            </div>

            <div class="row g-3">
                <div class="col-sm-8 py-3">
                    <label for="text" class="form-label">*Motivo</label>
                    <textarea type="text" class="form-control" v-model="motivo" required />
                </div>
            </div>

            <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">

                <button class="btn btn_color_system py-2 px-5 mt-4" type="button" @click="encerrarConta">
                    Encerrar minha conta
                </button>
            </div>
        </div>
        <div class="mt-5  text-center" v-if="sucesso">
            <p class="mt-5">
                <i class="fa-regular fa-circle-check icon"></i>
            </p>
            <p class="mt-3" style="font-size:18px;"><strong>Solicitação de encerramento de conta realizada com
                    sucesso!</strong>
            </p>
            <p class="mt-3">Em até 5 dias sua conta será encerrada, você receberá a confirmação pelo e-mail informado no
                seu cadastro.</p>
        </div>

        <Loading v-if="loading"></Loading>
    </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
    name: "EncerrarConta",
    props: [],
    components: { Loading },
    data() {
        return {
            loading: false,
            motivo: "",
            erro: "",
            sucesso: false
        }
    },
    methods: {
        encerrarConta() {
            this.erro = "";
            if (this.motivo) {
                this.loading = true;
                apiService
                    .encerrarConta(this.motivo)
                    .then(() => {
                        this.loading = false;
                        this.sucesso = true;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loading = false;
                        this.erro = error.response.data.title;
                    });
            } else {
                this.erro = "Informe o motivo por qual deseja encerrar sua conta."
            }
        }
    }
}
</script>
<style scoped>
.icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 56px;
    transition: 0.5s;
    color: var(--cor-secundaria);
    overflow: hidden;
}
</style>